import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=5bc3281e&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ConfirmOrder.vue?vue&type=style&index=1&id=5bc3281e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3281e",
  null
  
)

export default component.exports